export const ENDPOINT_DASHBOARD_RESOURCES_FIND_ALL = '/api/dashboard-resource/list';
export const ENDPOINT_DASHBOARD_RESOURCES_CREATE_ONE = '/api/dashboard-resource/create';
export const ENDPOINT_DASHBOARD_RESOURCES_UPDATE_ONE = '/api/dashboard-resource/update';
export const ENDPOINT_DASHBOARD_RESOURCES_DELETE_ONE = '/api/dashboard-resource/delete';
